import '../styles/componentStyles/MotivationTile.css';

import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

function MotivationTile({ width, colour, title, openModal, modalText, valueArr, data }) {
  const { t } = useTranslation();
  const titleId = title.replace(/\s+/g, '');

  return (
    <div
      className={`chart-container tile ${width}`}
      style={{
        borderColor: `${colour || 'rgba(98, 90, 106, 0.95)'}`,
      }}
      role="group"
      aria-labelledby={`${titleId}-motivation-tile-title`}
    >
      <div className="title-container">
        <h3
          className="title"
          style={{
            color: `${colour || '#fff'}`,
          }}
          id={`${titleId}-motivation-tile-title`}
        >
          {title}
        </h3>
        <button
          type="button"
          className="wtf transparent-button"
          onClick={() => openModal(title, modalText)}
        >
          <span className="visuallyHidden">{t('open.modal.extra.information')}</span>
          <FontAwesomeIcon icon={faQuestionCircle} className="wtf icon" />
        </button>
      </div>
      <div className="tile-content motivation fs-mask">
        <p>{t('DW027')}</p>
        {valueArr?.length > 0 && (
          <ul className="motivation-list" aria-label={title}>
            {data?.map((item, index) => {
              if (index < 3) {
                const reason = valueArr.find((e) => e.id === item);
                return <li key={item}>{t(reason.label)}</li>;
              }
              return '';
            })}
          </ul>
        )}
        {data?.length < 1 && <div className="empty">{t('D075')}</div>}
      </div>
    </div>
  );
}

export default MotivationTile;
